import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { EGoogleLib } from '@shared/models';
import { permissionGuard } from '@core/guards';
import { firebaseAuthResolver } from '@shared/services';
import { RoutesBasedPermissionsService } from '@core/services/routes-based-permissions.service';

import { homeRoutes } from '@feature/home/home.routes';
import { settingRoutes } from '@feature/setting/setting.routes';
import { customerRoutes } from '@feature/customer/customer.routes';
import { passengerRoutes } from '@feature/passenger/passenger.routes';
import { liveMapRoutes } from '@feature/live-map/live-map.routes';
import { driverRoutes } from '@feature/driver/driver.routes';
import { profileSettingsRoutes } from '@feature/profile-settings/profile-settings.routes';

import { ZMessagingProvider, ZNotificationsProvider } from '@core/providers';
import {
  mapLibraryResolver,
  mapLoaderResolver,
} from '@shared/services/map-loader.resolver';
import { interestZonesRoutes } from '@feature/interest-zones/interest-zones.routes';

export const MAIN_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./main-layout.component').then(m => m.MainLayoutComponent),
    resolve: { maps: mapLoaderResolver, firebase: firebaseAuthResolver },
    providers: [ZMessagingProvider, ZNotificationsProvider],
    children: [
      {
        path: '',
        redirectTo: () =>
          inject(RoutesBasedPermissionsService).getFirstAccessibleRouteUrl(),
        pathMatch: 'full',
      },
      {
        path: 'messaging',
        loadComponent: () =>
          import('@feature/messaging/messaging.component').then(
            m => m.MessagingComponent
          ),
        canActivate: [permissionGuard('DispatcherMessagingView')],
        resolve: {
          lib: mapLibraryResolver(
            EGoogleLib.places,
            EGoogleLib.marker,
            EGoogleLib.geometry
          ),
        },
      },
      {
        path: '403',
        loadComponent: () =>
          import('@core/pages/miscellaneous/access-denied.component').then(
            m => m.AccessDeniedComponent
          ),
      },
      {
        path: '404',
        loadComponent: () =>
          import('@core/pages/miscellaneous/not-found.component').then(
            m => m.NotFoundComponent
          ),
      },
      ...homeRoutes,
      ...liveMapRoutes,
      ...interestZonesRoutes,
      ...settingRoutes,
      ...customerRoutes,
      ...passengerRoutes,
      ...driverRoutes,
      ...profileSettingsRoutes,
    ],
  },
];
